import {
  LIST_SALE_LISTING_DATA,
  LIST_SALE_BUILT_LISTING_DATA,
  LIST_RENT_LISTING_DATA,
  LOADING_LIST_LISTING,
  SET_ALERT_LISTING,
  SET_SINGLE_LISTING,
} from '../../actions/types';

const initialState = {
  loading: false,
  isError: false,
  isErrorType: null,
  errMessage: null,
  saleData: [],
  saleBuiltData: [],
  rentData: [],
  singleData: {},
};

function listingReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_SINGLE_LISTING:
      return { ...state, singleData: payload };
    case LOADING_LIST_LISTING:
      return { ...state, loading: payload };
    case LIST_SALE_LISTING_DATA:
      return { ...state, saleData: payload };
    case LIST_SALE_BUILT_LISTING_DATA:
      return { ...state, saleBuiltData: payload };
    case LIST_RENT_LISTING_DATA:
      return { ...state, rentData: payload };
    case SET_ALERT_LISTING:
      return {
        ...state,
        isError: payload.isError,
        isErrorType: payload.isErrorType,
        errMessage: payload.errMessage,
      };
    default:
      return state;
  }
}

export default listingReducer;
